import { render, staticRenderFns } from "./Dojos.vue?vue&type=template&id=764a782a&"
import script from "./Dojos.vue?vue&type=script&lang=js&"
export * from "./Dojos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports